/**
 * @generated SignedSource<<6180888e32f52f5f2600c313d024de1a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Kind = "DISCORD_WEBHOOK" | "SLACK_ALERT" | "SLACK_CHANNEL" | "%future added value";
export type CreateNotificationIntegrationInput = {
  kind: Kind;
  name: string;
  webhookUrl: string;
};
export type DiscordIntegrationCreateNotificationIntegrationMutation$variables = {
  input: CreateNotificationIntegrationInput;
};
export type DiscordIntegrationCreateNotificationIntegrationMutation$data = {
  readonly createNotificationIntegration: {
    readonly notificationIntegration: {
      readonly id: any;
      readonly name: string;
      readonly webhookUrl: string | null | undefined;
    };
  };
};
export type DiscordIntegrationCreateNotificationIntegrationMutation = {
  response: DiscordIntegrationCreateNotificationIntegrationMutation$data;
  variables: DiscordIntegrationCreateNotificationIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateNotificationIntegrationPayload",
    "kind": "LinkedField",
    "name": "createNotificationIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLNotificationIntegration",
        "kind": "LinkedField",
        "name": "notificationIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "webhookUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DiscordIntegrationCreateNotificationIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiscordIntegrationCreateNotificationIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "82b1f0b563f257d8ac0bf19f0103a8f9",
    "id": null,
    "metadata": {},
    "name": "DiscordIntegrationCreateNotificationIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation DiscordIntegrationCreateNotificationIntegrationMutation(\n  $input: CreateNotificationIntegrationInput!\n) {\n  createNotificationIntegration(input: $input) {\n    notificationIntegration {\n      id\n      name\n      webhookUrl\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1beb94a004f04cd7415446b6a00adee8";

export default node;
